import axiosApi from "../axiosInstance";

const getMsmeList = async () => {
    try {
        const response = await axiosApi.get(`/Msme/GetMSMEList`);
        return response?.data;
    } catch (error) {
        console.log("Error getMsmeList===>:", error);
    }
};


export const MsmeService = {
    getMsmeList
}